// JS que pinta con datos actualizados informacion del pop cart, Ej. pop cart de menu

$(document).ready(function(){
    // variantes
    let items
    let total

    // acciones
    $('body').on('mouseenter', '.js-cart-pop-app__action', function(event) {
        cartPopApp()
        cartPopAppPrint()
        cartPopAppPrintTotal()
    })

    // funciones
    function cartPopApp() {
        $.ajax({
            type: 'GET',
            url: '/cart',
            dataType: 'html',
            async: false,
            success: res => {
                items = $(res).find('.js-cart-pop-app__item')
            }
        })
    }

    function cartPopAppPrint() {
        const formatter = new Intl.NumberFormat('en-US', {
            currency: 'USD',
            minimumFractionDigits: 2
        })

        if (items.length == 0) {
            $('.js-cart-pop-app__items').each( function (){
                $(this).html( cartPopAppItemsNull() )
            })
        }else{
            $('.js-cart-pop-app__items').html(' ')
            $('.js-cart-pop-app__items').append( items )
        }

    }

    function cartPopAppItemsNull(){
        let code = `
            <div class="text-center">    
                <blockquote class="mb-2">Su carrito está vacío.</blockquote>
            </div>
        `
        return code
    }

    function cartPopAppPrintTotal(){
        const formatter = new Intl.NumberFormat('en-US', {
            currency: 'USD',
            minimumFractionDigits: 2
        })

        total = 0
        $('.js-cart-pop-app__item').each( function (){
            total += $(this).data('cart-pop-app__price')
        })

        $('.js-cart-pop-app__total').each( function (){
            $(this).html(`$ ${formatter.format(total/100)}`)
        })
    }

})
